import commonService from "../../../services/Common/service";
import { removeCookie, setAuthCookies } from "../../../utils/cookies";
import {
  AuthActionTypes,
  CardActionTypes,
  ClientProfilesActionTypes,
  CommonActionTypes,
  ElgibleCurrenciesActions,
  ModulesActionTypes,
  UserInfoActionTypes,
} from "../../action-types";
import { startSessionExpirationTimers } from "../Session";

export const login = (user) => async (dispatch) => {
  dispatch({ type: CommonActionTypes.PENDING, payload: true });

  try {
    const checkMFA = process.env.REACT_APP_MFA === "true" ? true : false;
    if (checkMFA) {
      user.from_web = true;
    }
    const res = await commonService.post("/user/web-login", user);

    // if (res.data.success && res.data.token) {
    //   localStorage.setItem("user", JSON.stringify(res.data));
    // }

    // wait for the api, to be refactor for Rejected clients success from false to true"
    if (res.data.token && !checkMFA) {
      ResetCurrentSession();
      ResetReduxState(dispatch);

      setAuthCookies("token", res.data.token);
      setAuthCookies("user", res.data);
      dispatch({ type: AuthActionTypes.LOGIN, payload: res.data });
      // Set the session expiration timers
      dispatch(startSessionExpirationTimers());
    }

    return res.data;
  } catch (err) {
    const message = err.response.data.message || err.message;

    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });
    return err.response.data;
  } finally {
    dispatch({ type: CommonActionTypes.RESET, payload: true });
  }
};

export const userLogin = () => async (dispatch) => {
  try {
    let res = await commonService.post("/user/admin-login");

    if (res.data.token) {
      setAuthCookies("kyc_user", res.data);
    }
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};

export const logout = () => async (dispatch) => {
  dispatch({ type: CommonActionTypes.PENDING, payload: true });

  try {
    // dispatch({ type: AuthActionTypes.LOGOUT });
    await commonService.post("/user/logout");
  } catch (err) {
    const message = err.response.data.message || err.message;

    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });
  } finally {
    ResetReduxState(dispatch);
    ResetCurrentSession();
    removeCookie("token");
    removeCookie("user");
    return { success: true };
  }
};

export const UpdateRequestedKYC = (updatedUser) => {
  // localStorage.setItem("user", JSON.stringify(updatedUser));
  setAuthCookies("user", updatedUser);

  return {
    type: AuthActionTypes.UPDATE_REQUESTED_KYC,
    payload: updatedUser.kyc_requested,
  };
};

export const ImpersonateUser = (data) => async (dispatch) => {
  dispatch({ type: CommonActionTypes.PENDING, payload: true });

  try {
    const res = await commonService.post("/user/impersonate", data);

    if (res.data.token) {
      let user = res.data;
      user.impersonator = data.impersonator;
      user.impersonated = data.impersonated;
      user.key = data.key;
      user.isSwitch = true;

      ResetReduxState(dispatch);
      ResetCurrentSession();

      // localStorage.setItem("user", JSON.stringify(user));
      setAuthCookies("token", res.data.token);
      setAuthCookies("user", user);
      dispatch({ type: AuthActionTypes.LOGIN, payload: user });

      // Set the session expiration timers
      dispatch(startSessionExpirationTimers());
    }

    return res.data;
  } catch (err) {
    const message = err.response.data.message || err.message;

    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });
    return err.response.data;
  } finally {
    dispatch({ type: CommonActionTypes.RESET, payload: true });
  }
};

export const ResetCurrentSession = () => {
  const theme = localStorage.getItem("theme");
  const company = localStorage.getItem("company");

  // Remove auth cookies
  removeCookie("token");
  removeCookie("user");
  removeCookie("kyc_user");

  // Wipe all stored storage
  localStorage.clear();
  sessionStorage.clear();

  // Restore non-sensitive UI settings safely
  if (theme) {
    localStorage.setItem("theme", theme);
  }
  if (company && company !== "null") {
    localStorage.setItem("company", company);
  }
};

export const ResetReduxState = (dispatch) => {
  dispatch({ type: "RESET-ALL" });
  dispatch({ type: AuthActionTypes.LOGOUT });
  dispatch({
    type: ClientProfilesActionTypes.GET_ALL_CLIENT_PROFILES,
    payload: [],
  });
  dispatch({
    type: ElgibleCurrenciesActions.GET_ELIGIBLE_CURRENCIES,
    payload: [],
  });
  dispatch({ type: UserInfoActionTypes.USER_INFO, payload: null });
  dispatch({ type: ModulesActionTypes.RESET_MODULES, payload: null });
  dispatch({ type: CommonActionTypes.RESET, payload: true });
  dispatch({ type: CardActionTypes.SET_ACTIVE_CARD, payload: null });
  dispatch({ type: CardActionTypes.FETCH_CLIENT_CARDS, payload: [] });
};

export const SwitchUser = (data) => async (dispatch) => {
  // 1. Build destination URL safely
  const adminBase = (process.env.REACT_APP_FRIENDLY_WEB_ADMIN_URL || "").replace(/\/$/, "");
  const switchPath = (process.env.REACT_APP_SWITCH_ADMIN_PATH || "").replace(/^\//, "");
  
  const queryParams = new URLSearchParams({
    key: data.key ?? "",
    impersonator: data.impersonator ?? "",
    impersonated: data.impersonated ?? "",
  }).toString();

  const switchUserUrl = `${adminBase}/${switchPath}?${queryParams}`;

  // 2. Clear state and session data
  ResetReduxState(dispatch);
  ResetCurrentSession();

  // 3. Navigate using replace to omit the tokenized URL from browser back-button history
  // Dynamically set referrerPolicy to prevent leaking the query params to referrer logs
  const link = document.createElement("a");
  link.href = switchUserUrl;
  link.rel = "noreferrer noopener";
  link.referrerPolicy = "no-referrer";
  document.body.appendChild(link);
  link.click();
};
